import { ComponentType } from "react";
import { lowerCase, map, upperFirst } from "lodash";

import { IEventStatus } from "Bands/types";
import { colors } from "shared/styles/constants";
import { Checkmark, Question, Stop, Time } from "shared/assets/icons";
import { Icon } from "shared/styles";
import { ISelectOption } from "shared/components/Form/Fields/select/types";

export const getEventStatusIcons = (
  status?: IEventStatus
): { icon: ComponentType<any>; color: colors } => {
  switch (status) {
    case IEventStatus.confirmed:
      return { icon: Checkmark, color: colors.green };
    case IEventStatus.pending:
      return { icon: Time, color: colors.grey4 };
    case IEventStatus.onHold:
      return { icon: Time, color: colors.yellow };
    case IEventStatus.postponed:
      return { icon: Time, color: colors.red };
    case IEventStatus.canceled:
      return { icon: Stop, color: colors.red };
    default:
      return { icon: Question, color: colors.grey4 };
  }
};

export const eventStatuses: ISelectOption[] = map(IEventStatus, status => {
  const icon = getEventStatusIcons(status);

  return {
    icon: icon.icon,
    iconComponent: <Icon as={icon.icon} color={icon.color} />,
    value: status,
    label: upperFirst(lowerCase(status)),
  };
});
